import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { AlertController, NavController } from '@ionic/angular';
import { ConexionService } from './conexion.service';
import { UtilidadesService } from './utilidades.service';
import { Subject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class AppUpdateService {
  private version = 'v250327';
  
constructor(private readonly updates: SwUpdate, private alertController: AlertController,
  private conexion: ConexionService, public utilidades: UtilidadesService) {
  
}

private startUpdate = new Subject()
public startUpodate$ = this.startUpdate.asObservable()

public nextStartUpdate(val){
  this.startUpdate.next(val)
}


getVersion(){
  return this.version
}


verificarActualizaciones(){
  this.utilidades.Depuracion("Me suscribo a versionUpdates", "console", "")
  this.updates.versionUpdates.subscribe(event => {
    this.utilidades.Depuracion("versionUpdates respondio", "console", "")
    //this.showAppUpdateAlert();
    this.doAppUpdate();
  });
}

showAppUpdateAlert() {
  const header = '';
  const message = 'Choose Ok to update';
  const caller = this;
  // Use MatDialog or ionicframework's AlertController or similar
  this.doAppUpdate();
}

verificandoActualizaciones = false;

doAppUpdate() {
  this.utilidades.Depuracion("Revisando actualizaciones...", "console", "")

  this.verificandoActualizaciones = true;
  this.updates.checkForUpdate().then((resp)=>{
    this.verificandoActualizaciones = false;
    if(resp){
      this.utilidades.Depuracion("Actualizando...", "console", "")
      this.nextStartUpdate(true)
      //this.updates.activateUpdate().then(() => {

      this.conexion.VerificarVersion(this.version).subscribe((resp)=>{
        if(resp.Respuesta=="Exito"){
          if(resp.Datos == 1){
            this.utilidades.Depuracion("Version necesita reinicio", "console", "")
            let email = atob(localStorage.getItem(btoa("Email")))
            localStorage.clear()
            localStorage.setItem("TokenReinicioSesion", resp.Token)
            localStorage.setItem("EmailReinicioSesion", email)
          }
          setTimeout(() => {
            document.location.reload()
          }, 900);
        }
      })
       
      //}
    //  );
    }
    else{
      this.utilidades.Depuracion("No hay actualizaciones", "console", "")
      this.nextStartUpdate(false)
    }
  }, (err)=>{
    this.utilidades.Depuracion("Error al checkUpdate: " + String(err), "console", "")
    this.verificandoActualizaciones = false;
  })
   
  }

  async presentAlert() {
    const alert = await this.alertController.create({
      header: 'Hay una actualización de la app disponible, ¿deseas actualizar ahora?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
        },
        {
          text: 'Si',
          role: 'confirm',
          handler: () => { 
            this.doAppUpdate()
           }
        }
      ]
    });

    await alert.present();
  }
}